import { render, staticRenderFns } from "./MarketCrowdPush.vue?vue&type=template&id=064f01d4&scoped=true&"
import script from "./MarketCrowdPush.vue?vue&type=script&lang=js&"
export * from "./MarketCrowdPush.vue?vue&type=script&lang=js&"
import style0 from "./MarketCrowdPush.vue?vue&type=style&index=0&id=064f01d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064f01d4",
  null
  
)

export default component.exports